import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from '../../core/user.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(private auth: UserService, private router: Router) { }

  canActivate(): boolean {
    const isAuthenticated = this.auth.hasTokenValid();
    if (isAuthenticated) {
      this.router.navigate(['/dashboard']);
      return true;
    }
    return true;
  }
}
